import React, {useContext, useState} from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
import {labels, isNullOrEmpty, currentResource} from '../../../../../../../util/utils';
import {ListHeaderColumnTypes, entities as EntityTypes, estimateTypes} from '../../../../../../../util/uiconstants';
import ListHeader from '../../../../../../Main/Ares/Common/ListHeader/ListHeader';
import EntityDocuments from '../Common/EntityDocuments';
import CreateEntityForm from '../../../Common/CreateEntityForm/CreateEntityForm';
import RiskPills from '../../../../../RiskPills/index';

export default function EstimateList({estimate, engagement, documentTypeId, body, onCreateDocument}) {
	const getEstimateCategory = (riskTypeId) => {
		return currentResource.ShortRiskTypeForAres[riskTypeId];
	};

	const relatedDocuments = estimate.documents?.filter((document) => document.documentTypeID === documentTypeId) || {};

	const displayRiskPill = (parentRisks, showRiskTooltip = true) => {
		let riskList = [];
		parentRisks?.map((risk) => {
			riskList.push({
				id: risk.riskId,
				riskName: risk.riskName,
				riskTypeId: risk.riskTypeId
			});
		});

		//filter out duplicate risks
		const risks = riskList.filter(
			(value, index, self) => self.findIndex((risk) => risk && risk.id === value.id) === index
		);

		if (risks.length > 0) {
			return (
				<RiskPills
					closeTooltipOnOutsideClick
					risks={risks}
					className={'riskPillsContainer'}
					showTooltip={showRiskTooltip}
				/>
			);
		} else return <span className="noDataDash">{'-'}</span>;
	};

	const estimateComponentColumns = [
		{
			id: 'riskTypeId',
			type: ListHeaderColumnTypes.custom,
			title: labels.titleEstimateCategory,
			className: `styledAnalyticsIcon ${
				estimate.riskTypeId === estimateTypes.notSelected ? 'not-selected-estimate' : ''
			}`,
			render: () => getEstimateCategory(estimate?.riskTypeId)
		},
		{
			id: 'riskTypeId',
			type: ListHeaderColumnTypes.custom,
			title: labels.titleRisks,
			className: 'styledAnalytics',
			render: () => displayRiskPill(estimate?.parentRisks)
		}
	];

	return (
		<StyledEstimateList className="StyledEstimateList">
			<ListHeader
				name={estimate.riskName}
				columns={estimateComponentColumns}
				headerClassName={'styledAccountName'}
				secondColumns
			>
				<section className="createEntityAccount">
					<CreateEntityForm
						key={`createEntityAccount-${estimate.id}`}
						createLabel={labels.createDocument}
						entityId={EntityTypes.Estimate}
						objectIds={[estimate.id]}
						documentTypeId={documentTypeId}
						onCreateDocument={onCreateDocument}
						showDocuments={relatedDocuments && relatedDocuments.length > 0}
						selector={(store) => {
							const ids = store.entityDocuments.allIds?.filter((id) => {
								const entityDocument = store.entityDocuments.byId[id];

								return (
									entityDocument.smartEvidenceSourceId === estimate.id &&
									entityDocument.documentTypeId === documentTypeId
								);
							});

							return ids?.map((id) => {
								return store.entityDocuments && store.entityDocuments.byId && store.entityDocuments.byId[id];
							});
						}}
						render={({objectIds, entityForms}) => {
							return (
								<EntityDocuments
									key={`entityDocuments-${estimate.id}`}
									entityUId={objectIds[0]}
									documents={entityForms}
									hasRelateTask
								/>
							);
						}}
					/>
				</section>
			</ListHeader>
		</StyledEstimateList>
	);
}

const StyledEstimateList = styled.section`
	display: flex;
	width: 100%;
	margin-bottom: var(--px-24);
	&:last-child {
		margin-bottom: 0;
	}
	.openAnalyticDocumentation {
		border-top: var(--px-1) solid var(--neutrals-300);
		margin-top: var(--px-16);
		padding-top: var(--px-16);
		display: flex;
		align-items: center;
		width: 100%;
		.motif-icon {
			display: inline-flex;
			align-items: center;
			svg {
				width: var(--px-16) !important;
				height: var(--px-16) !important;
				color: var(--blue-600);
			}
		}
		.openAnalyticDocumentationLabel {
			margin-left: var(--px-3);
			font-size: var(--px-14);
			font-weight: 700;
			color: var(--blue-600);
			display: inline-flex;
		}
	}
	.tooltiplabel {
		display: inline-flex;
		&.showTxt {
			cursor: pointer;
			font-size: var(--px-14);
			font-weight: 700;
			line-height: var(--px-22);
			color: var(--blue-600);
		}
	}
	.DisplayAmount {
		display: inline-flex;
		&.showTxt {
			cursor: pointer;
			font-size: var(--px-14);
			font-weight: 700;
			line-height: var(--px-22);
			color: var(--blue-600);
			&:hover {
				text-decoration: underline;
			}
		}
	}
	.executionTypeLabel {
		margin-left: var(--px-16);
		border: var(--px-1) solid var(--neutrals-900);
		border-radius: var(--px-12);
		padding: var(--px-10);
		height: var(--px-24);
		display: inline-flex;
		align-items: center;
		width: auto;
		max-width: var(--px-200);
		cursor: default;
		user-select: none;
		.executionTypeText {
			font-size: var(--px-12);
			font-weight: 400;
			line-height: var(--px-16);
			color: var(--neutrals-900);
		}
	}
	.RiskPillsContainer {
		display: inline-flex;
		margin-right: var(--px-24);
		height: var(--px-24);
		align-items: center;
		.motif-dropdown-portal {
			display: inline-flex;
			.motif-dropdown-trigger {
				display: inline-flex;
			}
		}
		svg {
			color: var(--neutrals-800);
			height: inherit;
		}
	}

	.columnListRight {
		display: flex;
		justify-content: flex-end;
		width: var(--px-400);
		flex: 1;
		.firstRowColumns {
			.styledAnalyticsIcon {
				width: var(--px-500);
				flex-grow: 1;
				.StyledColumnHeader {
					color: var(--neutrals-700);
				}
				&.not-selected-estimate {
					.StyledColumnValue {
						color: var(--red-500);
					}
				}
			}
			.styledAnalytics {
				width: var(--px-140);
				.StyledColumnHeader {
					color: var(--neutrals-500);
				}
			}
		}
	}
	.createEntityAccount {
		.relatedDocumentsItemWrapperContainer {
			.relatedDocuments__row {
				display: flex;
				.relatedDocumentDocName {
					width: calc(100% - var(--px-390));
					.DocumentNameDetails {
						height: var(--px-40);
						.DocumentNameText {
							.DocumentName {
								color: var(--blue-600) !important;
							}
						}
					}
				}
				.section-validationCount {
					margin-left: auto;
				}
				.body-quick-reference_row_review-notes {
					padding: 0 var(--px-16);
				}
				.body-quick-reference__row__sign-offs {
					padding: 0 var(--px-16);
					.StyledSignOff {
						.StyledSignOffItem {
							margin-right: var(--px-12);
							.signOffContainer {
								.MotifDropDownPortalWrapper {
									.motif-dropdown {
										.signOffButton {
											margin-left: var(--px-4);
											.btnLabel {
												justify-content: center !important;
												width: var(--px-30);
												.signOffLabel {
													display: inline;
													width: 100%;
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
	.styledAccountName {
		display: flex;
		width: calc(100% - var(--px-700)) !important;
	}
`;
